/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import { httpApiGet, httpApiPost, httpApiPut, httpApiDelete } from '@amzn/base-ui/dist/helpers/api';

function getAnnouncements() {
  return httpApiGet('api/announcements/admin');
}

function createAnnouncement(data) {
  return httpApiPost('api/announcements/admin', { data });
}

function updateAnnouncement(id, data) {
  return httpApiPut(`api/announcements/admin/${id}`, { data });
}

function deleteAnnouncement(id, rev) {
  return httpApiDelete(`api/announcements/admin/${id}`, { data: { rev } });
}

export { getAnnouncements, createAnnouncement, updateAnnouncement, deleteAnnouncement };
